import { ITypedReduxAction } from '../../types/redux/actionType';

export enum ESavedSearchNotificationActionTypes {
  Visible = 'saved_searches/notification/VISIBLE',
}

export interface ISavedSearchNotificationPayload {
  visible: boolean;
}

export type TSavedSearchNotificationVisible = ITypedReduxAction<
  ESavedSearchNotificationActionTypes.Visible,
  ISavedSearchNotificationPayload
>;

export type TSavedSearchNotificationActions = TSavedSearchNotificationVisible;
